import { Qualification } from '@libs/models/talents';
import { request } from '../request';

export function fetchJobQualifications() {
  return request.get<{ nurses: Qualification[]; other: Qualification[] }>('/v2/settings/qualifications');
}
